import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { identifyComponent } from '../../util';
import css from './index.module.scss';

export interface TextInputBaseProps extends Omit<React.ComponentPropsWithoutRef<'input'>, 'size'> {
  /**
   * For element identity and testing purposes. Defaults to 'text-input'
   */
  testId?: string;
  /**
   * If true, the input will not be able to be selected or clicked.
   */
  disabled?: boolean;
  /**
   * If true, the input will be marked as invalid
   */
  invalid?: boolean;
  /**
   * When true, the input's width will be 100%
   */
  fullWidth?: boolean;
}

export const TextInputBase = React.forwardRef<HTMLInputElement, TextInputBaseProps>(
  (
    {
      disabled = false,
      id,
      invalid = false,
      placeholder,
      testId = 'text-input',
      onBlur,
      onFocus,
      ...rest
    },
    ref,
  ) => (
    <input
      data-component="TextInputBase"
      aria-invalid={invalid}
      data-testid={testId}
      disabled={disabled}
      id={id}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      className={classNames(css.hideOverflow)}
      ref={ref}
      {...rest}
      {...identifyComponent('text-input', rest)}
    />
  ),
);
TextInputBase.displayName = 'TextInputBase';
